import { useEffect, useRef, useState } from "react";
import { charCodeType } from "../../../../../common/CharCode.type";

type PropsType = {
  charCode: charCodeType;
  setCharCode: (v: charCodeType) => void;
  kind: "import" | "export";
  disabled?: boolean;
  resetSignal: number;
};

const charCodeLabels: Record<string, string> = {
  utf8: "UTF-8（BOM無し）",
  utf8bom: "UTF-8（BOM付き）",
  sjis: "Shift-JIS(Excelなど)",
};

const SelectCharCode = ({ charCode, setCharCode, disabled, resetSignal }: PropsType) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [hasSelectedCharCode, setHasSelectedCharCode] = useState(false);

  useEffect(() => {
    setHasSelectedCharCode(false);
    setOpen(false);
  }, [resetSignal]);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (disabled) {
      setHasSelectedCharCode(false);
    }
  }, [disabled]);

  const handleSelect = (code: charCodeType) => {
    if (disabled) return;
    setCharCode(code);
    setHasSelectedCharCode(true);
    setOpen(false);
  };

  const buttonLabel = (() => {
    if (disabled) return "文字コード";
    if (!hasSelectedCharCode) return "文字コード";
    return charCodeLabels[charCode];
  })();

  return (
    <div className="ms-2" ref={dropdownRef} style={{ position: "relative" }}>
      <button
        className="btn btn-light dropdown-toggle"
        onClick={() => !disabled && setOpen(!open)}
        disabled={disabled}
      >
        {buttonLabel}
      </button>

      {open && (
        <ul
          className="dropdown-menu show"
          style={{
            display: "block",
            position: "absolute",
            top: "100%",
            left: 0,
            zIndex: 999,
            minWidth: '100%',
          }}
        >
          <li>
            <button className="dropdown-item" onClick={() => handleSelect("utf8")}>
              UTF-8（BOM無し）
            </button>
          </li>
          <li>
            <button className="dropdown-item" onClick={() => handleSelect("utf8bom")}>
              UTF-8（BOM付き）
            </button>
          </li>
          <li>
            <button className="dropdown-item" onClick={() => handleSelect("sjis")}>
              Shift-JIS(Excelなど)
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default SelectCharCode;
